import type React from 'react'
import { useContext } from 'react'

export const useStrictContext = <T>(
  ctx: React.Context<T | null>,
  name: string
) => {
  const value = useContext(ctx)

  if (!value) {
    throw new Error(`Context ${name} consumer is used without provider`)
  }

  return value
}
